module.exports = __webpack_public_path__ + "static/media/mute_red.ffc2473e.svg";